module.exports = __webpack_public_path__ + "img/add-fav.ff4e8715.svg";